import React from 'react'
// import { useNavigate } from "react-router-dom";
import { useCookies } from 'react-cookie';
import { useUser } from "../context/UserContext";
import config from '../config';
import googleLogo from "../assets/Google-g-icon.png";

export default function LoginGoogle() {
    // const navigate = useNavigate();
    const { loginUser } = useUser();
    const [cookies, setCookie] = useCookies([]);

    const handleGoogleLogin = async () => {
        try {
            // Open Google OAuth page in a new window
            window.open(
                `${config.apiBaseUrl}/auth/google`,
                "_blank",
                "width=800,height=600"
            );

            // Listen for messages from the OAuth window
            const receiveMessage = async (event) => {
                if (event.origin !== config.apiBaseUrl) return; // Ensure the message is from your backend

                if (event.data) {
                    // console.log(event.data)

                    // Store user data in state or context (optional)
                    // setUser(event.data);
                    loginUser(event.data.user_data);

                    // server response cannot set cookie in redirect
                    const cookie_data = event.data.cookie_data;
                    setCookie(cookie_data.key, cookie_data.value, {
                        expires: new Date(Date.now() + cookie_data.max_age * 1000),
                        secure: true,
                        sameSite: 'lax'
                    });

                    // Redirect to the home page with user data
                    // navigate("/", { state: { user: event.data } });
                    // navigate("/");
                }
            };
            window.addEventListener("message", receiveMessage);

            // Clean up the event listener
            return () => {
                window.removeEventListener("message", receiveMessage);
            };
    
        } catch (error) {
            console.error("Google login error:", error);
        }
    };

    return (
        <img
            src={googleLogo}
            alt="Google Login"
            className="w-9 h-9 mx-4 duration-300 hover:scale-120"
            onClick={handleGoogleLogin}
        />                
    )
}
